/**
 * The numbered heading each drawer section wears (#1911).
 *
 * Its own module because four sections use it and none of them owns it — when
 * it lived inside the draft form, the recipients and send sections imported a
 * component out of a file about something else, and the import read like a
 * dependency they did not have.
 */
interface Props {
  readonly index: number;
  readonly title: string;
  readonly hint: string;
}

export function SectionCaption({ index, title, hint }: Props): JSX.Element {
  return (
    <div className="flex flex-col gap-0.5">
      <h3 className="m-0 flex items-center gap-2 text-section text-paper">
        <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-signal-dim font-mono text-micro text-signal">
          {index}
        </span>
        {title}
      </h3>
      <p className="m-0 text-micro text-paper-low">{hint}</p>
    </div>
  );
}
